import * as React from 'react'
import { Search } from 'lucide-react'
import { cn } from '@/lib/utils'

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
    ({ className, type, ...props }, ref) => {
        return (
            <input
                type={type}
                className={cn(
                    'flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:border-primary disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
                    className,
                )}
                ref={ref}
                {...props}
            />
        )
    },
)
Input.displayName = 'Input'

interface IconInputProps extends React.ComponentPropsWithoutRef<'input'> {
    icon?: React.ReactNode
}

const IconInput = React.forwardRef<HTMLDivElement, IconInputProps>(
    ({ className, icon, ...props }, ref) => {
        return (
            <div ref={ref} className={cn('relative w-full', className)}>
                {icon || (
                    <Search className="absolute left-2.5 top-2.5 size-4" />
                )}
                <Input className="pl-8" {...props} />
            </div>
        )
    },
)
IconInput.displayName = 'IconInput'

export { Input, IconInput }
